// @flow strict

import * as React from 'react';

type PropTypes = {|
  symbol: '',
  componentStyle: {},
|};

export const TradingViewAdvancedChartBase = (props: { ...PropTypes }) => {
  return (
    <div className="tradingview-component" style={props.componentStyle}>
      <div className="i-tradingview-component">
        <div className="tradingview-widget-container">
          <div className="devotion-tv-advanced-chart" />
          <div className="tradingview-widget-copyright">
            <a
              href="https://www.tradingview.com/symbols/ASX-AND/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="blue-text">ASX: AND</span>
            </a>
            &nbsp;Chart by TradingView
          </div>
        </div>
      </div>
    </div>
  );
};

const TradingViewAdvancedChart = (props: PropTypes) => <TradingViewAdvancedChartBase {...props} />;

export default TradingViewAdvancedChart;
